import { useCallback, useRef, useEffect } from 'react';
import { reaction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useWorkspacePanel } from '../panels/hooks/use-workspace-panel';
import { useOpenEventPanel } from './use-open-event-panel';
import { EventNarrative } from '../event-narrative';

export const EventPanelNarrative = observer(
    (): React.ReactElement => {
        const panel = useWorkspacePanel();
        const { linkedEntityId: agencyEventId } = panel ?? {};
        const focusInputRef = useRef<() => void>();
        const openEventPanel = useOpenEventPanel();

        const onOpenEventPanel = useCallback(
            (id: number) => {
                openEventPanel({ eventId: id, shouldFocusPanel: true });
            },
            [openEventPanel]
        );

        useEffect(() => {
            const disposer = reaction(
                () => panel.isFocused,
                (isPanelFocused) => {
                    if (isPanelFocused && focusInputRef.current) {
                        focusInputRef.current();
                    }
                },
                { fireImmediately: true }
            );
            return disposer;
        }, [panel]);

        return (
            <EventNarrative
                eventId={agencyEventId}
                onOpenEvent={onOpenEventPanel}
                isPanelFocused={panel.isFocused}
            />
        );
    }
);
